import {MutationTree} from 'vuex';
import {Toast, ToastInitState} from '@/store/toast/toast.types';


export const ToastMutations: MutationTree<ToastInitState> = {
  ['notifyToast'](state: ToastInitState, payload: Toast) {
    state.toast = payload;
  }
};
